import { render, staticRenderFns } from "./teachersDashbord.vue?vue&type=template&id=179e592e&"
import script from "./teachersDashbord.vue?vue&type=script&lang=js&"
export * from "./teachersDashbord.vue?vue&type=script&lang=js&"
import style0 from "./teachersDashbord.vue?vue&type=style&index=0&id=179e592e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports